import { Column, CreateDateColumn, Entity, JoinColumn, ManyToOne, PrimaryGeneratedColumn, UpdateDateColumn, VersionColumn } from "typeorm";
import { StylesEntity } from "./style-carhartt.entity";
import { UnitSevenStatusEnum, WfxCarharttEnum } from "@project-management-system/shared-models";

@Entity('measurement_data')
export class MeasurementDataEntity {
    @PrimaryGeneratedColumn('increment', {
        name: 'id'
    })
    id: number;

    @Column('varchar', {
        nullable: true,
        length: 300,
        name: 'measurement_data'
    })
    measurementData: string;

    @Column('enum', {
        nullable: true,
        name: 'trim_card',
        enum: WfxCarharttEnum
    })
    trimCard: WfxCarharttEnum;

    @Column('enum', {
        nullable: true,
        name: 'status',
        enum: UnitSevenStatusEnum
    })
    status: UnitSevenStatusEnum;

    @Column("boolean", {
        nullable: true,
        default: true,
        name: "is_active"
    })
    isActive: boolean;

    @CreateDateColumn({
        nullable: true,
        name: "created_at",
        type: "datetime"
    })
    createdAt: Date;

    @Column("varchar", {
        nullable: true,
        name: "created_user",
        length: 50
    })
    createdUser: string | null;

    @UpdateDateColumn({
        name: "updated_at",
        type: 'datetime',
        nullable: true,
    })
    updatedAt: Date;

    @Column("varchar", {
        nullable: true,
        name: "updated_user",
        length: 50
    })
    updatedUser: string | null;

    @VersionColumn({
        nullable: true,
        default: 1,
        name: "version_flag"
    })
    versionFlag: number;

    @Column('int', {
        nullable: true,
        name: 'style_id',
    })
    styleId: number

    @Column('varchar', {
        nullable: true,
        length: 300,
        name: 'color'
    })
    color: string;
   
    @Column('varchar', {
        nullable: true,
        length: 300,
        name: 'shade'
    })
    shade: string;

    @ManyToOne(type => StylesEntity, styles => styles.measurement)
    @JoinColumn({ name: 'style_id' })
    styles: StylesEntity

}